import deepmerge from 'deepmerge';

export const addBookmark = bookmark => {
  return (dispatch, getState) => {
    const { courseId } = getState().CourseState;

    let liSplit = bookmark.split('.');
    let mod = liSplit[0];
    let block = liSplit[1];
    // set up the new bookmark to add
    let newBookmark = {
      [courseId]: {
        list: [bookmark],
        structure: { [mod]: { [block]: [bookmark] } }
      }
    };
    // get bookmarks from local storage
    const bookmarksLs = localStorage.getItem('netacad-Bookmarks');
    // parse LS if available, otherwise blank object
    let currentBookmarks = bookmarksLs ? JSON.parse(bookmarksLs) : {};

    // if we don't have bookmarks for the course, set some placeholders
    if (!currentBookmarks[courseId]) {
      currentBookmarks[courseId] = { list: [], structure: {} };
    }
    // merge the new bookmark with ones we have already
    const merged = deepmerge(newBookmark, currentBookmarks);
    // off to local storage
    localStorage.setItem('netacad-Bookmarks', JSON.stringify(merged));
    // Tell redux
    dispatch({
      type: 'UPDATE_BOOKMARKS'
    });
    // eslint-disable-next-line no-console
    console.log(`chunk ${bookmark} is bookmarked`);
  };
};

export const removeBookmark = bookmark => {
  return (dispatch, getState) => {
    const { courseId } = getState().CourseState;
    let liSplit = bookmark.split('.');
    let mod = liSplit[0];
    let block = liSplit[1];
    // garanteed to have local storage. can't remove without having added first.
    let bookmarksLs = JSON.parse(localStorage.getItem('netacad-Bookmarks'));
    // bookmarks for the course.
    let bookmarks = bookmarksLs[courseId];
    // remove the bookmark
    bookmarks.list.splice(bookmarks.list.indexOf(bookmark), 1);
    bookmarks.structure[mod][block].splice(
      bookmarks.structure[mod][block].indexOf(bookmark),
      1
    );
    // if it's the last bookmark in a module, remove the module
    if (!bookmarks.structure[mod][block].length) {
      delete bookmarks.structure[mod][block];
    }

    // add modified bookmark object to the bookmarks object (with all course bookmarks)
    bookmarksLs[courseId] = bookmarks;
    // save to local storage
    localStorage.setItem('netacad-Bookmarks', JSON.stringify(bookmarksLs));
    // tell redux
    dispatch({
      type: 'UPDATE_BOOKMARKS'
    });
    console.log(`chunk ${bookmark} is removed from bookmarks`);
  };
};
